import React, { FC, useEffect, useState } from 'react';
import { SearchOutlined } from '@mui/icons-material';
import { IconButton, StandardTextFieldProps, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface SearchInputProps extends StandardTextFieldProps {

  defaultValue?: string

  setSearchValue: (value: string) => void;

  debounceTime?: number

}

const SearchInput: FC<SearchInputProps> = ({ defaultValue = '', setSearchValue, debounceTime = 0, ...props }) => {

  const [value, setValue] = useState<string>(defaultValue);

  const [debouncedValue, setDebouncedValue] = useState<string>('');

  const [showClear, setShowClear] = useState<boolean>(defaultValue !== '');

  const handleSearchChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {

    setValue(event.target.value);

    setShowClear(event.target.value !== '');

  };

  const handleSearchClick = () => {

    setValue('');

    setShowClear(showClear ? !showClear : showClear);

  }

  useEffect(() => {

    const handler = setTimeout(() => {

      setDebouncedValue(value);

    }, debounceTime);

    return () => {

      clearTimeout(handler);

    };

  }, [value]);

  useEffect(() => {

    setSearchValue(debouncedValue);

  }, [debouncedValue]);

  return (

    <TextField
      variant="outlined"
      {...props}
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        (theme) => ({
          backgroundColor: 'white',
          '.MuiInputBase-root': { paddingRight: '8px', height: '35px' },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderWidth: '2px',
              borderColor: theme.colors.primary
            }
          }
        })]}
      value={value}
      slotProps={{
        input: {
          endAdornment: (
            <IconButton onClick={handleSearchClick}>
              {showClear &&
                <CloseIcon />
              }
              {!showClear &&
                <SearchOutlined />
              }
            </IconButton>
          )
        }
      }}
      onChange={handleSearchChange} />

  )

};

export default SearchInput;
